import { render, staticRenderFns } from "./image-modal.vue?vue&type=template&id=2010a62c&"
import script from "./image-modal.vue?vue&type=script&lang=js&"
export * from "./image-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports